import React from "react";
import { Grid, Typography } from "@material-ui/core";
import useChangeSociety from "@icarius-app/components/wrapper/hooks/useChangeSociety";
import SocietySelectDialog from "@icarius-pages/login/components/societySelectDialog";
import Clock from "./clock";

const SocietyClockHeader = () => {
    const {
        canChangeSociety,
        societySelected,
        societyOptions,
        changeSocietyDialogIsOpen,
        handleChangeSociety,
        handleOpenChangeSocietyDialog,
        handleCloseChangeSocietyDialog,
    } = useChangeSociety();

    return (
        <>
            <Grid container justify="space-between" style={{ padding: "10px 24px", paddingBottom: 10 }}>
                <Grid item sm={12} md={6}>
                    <Typography
                        className="whiteText myDesktopClockText"
                        style={{
                            textDecoration: canChangeSociety ? "underline" : "",
                            cursor: canChangeSociety ? "pointer" : "",
                        }}
                        onClick={canChangeSociety ? handleOpenChangeSocietyDialog : null}
                    >
                        {societySelected.name}
                    </Typography>
                </Grid>
                <Clock />
            </Grid>
            {changeSocietyDialogIsOpen && (
                <SocietySelectDialog
                    open={changeSocietyDialogIsOpen}
                    handleCloseDialog={handleCloseChangeSocietyDialog}
                    handleCancelDialog={handleCloseChangeSocietyDialog}
                    handleConfirm={handleChangeSociety}
                    actualSociety={societySelected}
                    options={societyOptions}
                />
            )}
        </>
    );
};

export default SocietyClockHeader;
